/** Minimum time the stream range start (`from`) must be in the past (20 minutes). */
export const MIN_STREAM_FROM_LOOKBACK_MS = 20 * 60 * 1000;

/** Safety buffer for stream range end (`to`): cap latest end at `now - 30s`. */
export const MAX_STREAM_TO_LOOKBACK_MS = 30 * 1000;

/** Path prefix for logger stream routes: /logger/s/:slug */
export const LOGGER_STREAM_PATH = '/logger/s';

/** Fallback retention days (~10 years) when `station.retentionDays` is unset or `0` (streamable bounds and time-move). */
export const STREAM_RETENTION_DAYS_DEFAULT = 365 * 10;

/** Fixed stream window duration used by navigation/init range loaders (1 hour). */
export const STREAM_RANGE_DURATION_MS = 60 * 60 * 1000;

/** Minimum focus selection span in the preview brush (5 minutes). */
export const PREVIEW_MIN_SELECTION_LENGTH_MS = 5 * 60 * 1000;

/** Layout and interaction constants for the logger stream screen (preview, focus, editor, tracks). */
export const STREAM_UI_CONFIG = {
  focusChangeThrotleMs: 50,
  defaultFocusLengthMins: 15,
  previewHeight: 105,
  previewHeightCollapsed: 70,
  focusHeightExpanded: 240,
  focusHeightCollapsed: 180,
  editorHeightExpanded: 160,
  editorHeightCollapsed: 40,
  focusTracksHeight: 24,
} as const;
